var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#171717",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42415 2.57572C9.65847 2.81002 9.65849 3.18992 9.42418 3.42425L3.44885 9.40003L17.9999 9.4C18.3313 9.4 18.5999 9.66863 18.5999 10C18.5999 10.3314 18.3313 10.6 17.9999 10.6L3.44885 10.6L9.42418 16.5757C9.65849 16.8101 9.65847 17.19 9.42415 17.4243C9.18983 17.6586 8.80993 17.6586 8.57562 17.4242L1.57611 10.4243C1.34182 10.19 1.34182 9.81009 1.57611 9.57578L8.57562 2.57575C8.80993 2.34143 9.18983 2.34141 9.42415 2.57572Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b29858fcb12cdebaab7ad409677f9fe2.svg";
export { ForwardRef as ReactComponent };